exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SparkView-module__wrapper___r4T97 .SparkView-module__top___3lU3B{display:grid;grid-template-columns:auto auto;gap:.5rem;justify-content:space-between}.SparkView-module__wrapper___r4T97 .SparkView-module__top___3lU3B .SparkView-module__search___3SdBm{grid-column:1/3}@media screen and (min-width:525px){.SparkView-module__wrapper___r4T97 .SparkView-module__top___3lU3B{grid-template-columns:1fr auto .35fr}.SparkView-module__wrapper___r4T97 .SparkView-module__top___3lU3B .SparkView-module__search___3SdBm{grid-column:initial}}.SparkView-module__wrapper___r4T97 .SparkView-module__description___12ueR span{color:#8450f8;cursor:pointer}.SparkView-module__wrapper___r4T97 .SparkView-module__content___2NjWx{padding-top:2.5rem;display:grid;gap:1rem}.SparkView-module__wrapper___r4T97 .SparkView-module__content___2NjWx .SparkView-module__groups____DNSI{display:grid;gap:.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "SparkView-module__wrapper___r4T97",
	"top": "SparkView-module__top___3lU3B",
	"search": "SparkView-module__search___3SdBm",
	"description": "SparkView-module__description___12ueR",
	"content": "SparkView-module__content___2NjWx",
	"groups": "SparkView-module__groups____DNSI"
};